import { render, staticRenderFns } from "./AppPhone.vue?vue&type=template&id=233295b4&scoped=true&"
import script from "./AppPhone.vue?vue&type=script&lang=js&"
export * from "./AppPhone.vue?vue&type=script&lang=js&"
import style0 from "./AppPhone.vue?vue&type=style&index=0&id=233295b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233295b4",
  null
  
)

export default component.exports